<div class="detail-container">
  <div class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">
    <div class="innertitletxt">
      Profil utilisateur :
      <span *ngIf="isDetailMode"> modification</span>
      <span *ngIf="!isDetailMode"> création</span>
    </div>

    <div class="card" *ngIf="!isDetailMode">
      <div class="card-body">
        <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
          <div fxLayout="row" fxFlex="100">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Rechercher un utilisateur</mat-label>
              <input matInput hidden readonly>
              <ng-select name="activeDirectoryUsers" [items]="userSuggestions" [hideSelected]="true" [typeahead]="searchInput$" [loading]="loading" (change)="onChangeSelectSuggestion($event)"
                notFoundText="Aucun utilisateur trouvé">

                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="suggestion-preview">
                    <strong>{{item.LastName}} {{item.FirstName}}</strong>
                  </div>
                  <div class="suggestion-preview">
                    {{item.Email}}
                  </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{item.LastName}} {{item.FirstName}}
                </ng-template>
              </ng-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
          <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
            <div fxFlex="25" fxFlex.gt-sm="25">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Prénom </mat-label>
                <input matInput value="{{userDetail.FirstName}}" type="text" readonly disabled>
              </mat-form-field>
            </div>
            <div fxFlex="25" fxFlex.gt-sm="25">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Nom</mat-label>
                <input matInput value="{{userDetail.LastName}}" type="text" readonly disabled>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.gt-sm="50">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput value="{{userDetail.Email}}" type="text" readonly disabled>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
            <div fxFlex="25" fxFlex.gt-sm="25">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Date d'ajout</mat-label>
                <input matInput value="{{userDetail.CreationDate | date:'dd/MM/yyyy'}}" type="text" readonly disabled>
              </mat-form-field>
            </div>
            <div fxFlex="25" fxFlex.gt-sm="25">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Actif</mat-label>
                <input matInput value="userDetail.IsActive" hidden readonly>
                <mat-slide-toggle [(ngModel)]="userDetail.IsActive" [disabled]="canDeactivateUser" tooltip="Activer/Désactiver" class="customToggle">
                </mat-slide-toggle>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div fxLayout=”row” fxLayoutAlign="end">
      <button mat-stroked-button class="currentBtnColor" (click)="$event.stopPropagation();exportGroupsAsExcel();" tooltip="Exporter au format excel">
        <mat-icon>download</mat-icon>
        <span fxHide fxShow.gt-md>Exporter sur Excel</span>
      </button>
    </div>

    <div class="card">
      <div class="card-header">
        Groupes
      </div>
      <div class="card-body">
        <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
          <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
            <div fxFlex="80" fxFlex.gt-sm="80" class="dropDownStyle">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Recherche de groupe </mat-label>
                <input matInput hidden readonly>
                <ng-multiselect-dropdown (onSelect)="onSelectGroup($event,'select')" (onDeSelect)="onSelectGroup($event,'deselect')" (onDeSelectAll)="onSelectGroup($event,'deselectall')"
                  (onSelectAll)="onSelectGroup($event,'selectall')" [settings]="groupDropDownSettings" [data]="groups" (onFilterChange)="onGroupFilterChange(null, $event)"
                  [(ngModel)]="selectedItemsGroups" [disabled]="!userDetail.Id || userDetail.SelectAllGroups">
                </ng-multiselect-dropdown>
              </mat-form-field>
            </div>
            <div fxFlex="10" fxFlex.gt-sm="10">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Sélectionner tout </mat-label>
                <input matInput hidden readonly>
                <mat-slide-toggle [(ngModel)]="userDetail.SelectAllGroups" (click)="selectAllPages()" tooltip="Sélectionner tout" class="customToggle">
                </mat-slide-toggle>
              </mat-form-field>
            </div>
            <div fxFlex="10" fxFlex.gt-sm="10">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Supprimer groupes </mat-label>
                <input matInput hidden readonly>
                <mat-slide-toggle [(ngModel)]="userDetail.DeleteAllOtherPages" (click)="deleteAllOtherPages()" tooltip="Supprimer les groupes des autres pages" class="customToggle">
                </mat-slide-toggle>
              </mat-form-field>
            </div>
          </div>

          <div class="item-delete" fxLayout="row" fxFlex="100" fxLayoutAlign="start" [hidden]="userDetail.Groups.length == 0">
            <mat-checkbox (change)="selectAll($event)" [disabled]="userDetail.SelectAllGroups"></mat-checkbox>
            <span class="material-icons" [hidden]="!hasAnySelectedLines" (click)="onRemoveSelected()">
              delete_forever
            </span>
          </div>

          <div class="item-container" fxLayout="row" fxFlex="100" fxLayoutAlign="start" *ngFor="let group of userDetail.Groups">
            <div fxFlex="80" fxFlex.gt-sm="80">
              <mat-checkbox [(ngModel)]="groupLines[group.Id].Selected" [disabled]="userDetail.SelectAllGroups">
              </mat-checkbox>
              {{group.Name}}
            </div>
            <div fxFlex="10" fxFlex.gt-sm="10">
              <mat-slide-toggle [(ngModel)]="group.IsSupervisor" [disabled]="!groupLines[group.Id].CanSetSupervisor" tooltip="Définir en tant que référent sur ce groupe"
                name="IsSupervisor_{{group.Id}}" (change)="userGroupChanged(group)">
              </mat-slide-toggle>
            </div>
            <div fxFlex="10" fxFlex.gt-sm="10">
              <button mat-button [disabled]="userDetail.SelectAllGroups" (click)="onRemove(group)">
                <mat-icon [ngClass]="{'disabled': userDetail.SelectAllGroups}">
                  delete_forever
                </mat-icon>
              </button>
            </div>
          </div>

          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start end">
            <mat-paginator [pageSize]="defaultPageSize" [pageSizeOptions]="[10,15, 20, 25, 30]" showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div fxLayout=”row” fxLayoutAlign="end" class="bottom-bar">
    <div fxLayout=”row” fxLayoutAlign="end">
      <div class="btnSpacerCol">
        <button mat-stroked-button class="currentBtn" matTooltip="Vider le cache du profil" (click)="onClearCache()">
          <mat-icon>auto_delete</mat-icon>
          <span class="long-btn-span large" fxHide fxShow.gt-md>Vider le cache du profil</span>
        </button>
      </div>
      <div class="btnSpacerCol">
        <button mat-stroked-button class="currentBtn" matTooltip="Annuler" (click)="onCancel()">
          <mat-icon>cancel</mat-icon>
          <span class="long-btn-span" fxHide fxShow.gt-md>Annuler</span>
        </button>
      </div>
      <div class="btnSpacerCol">
        <button mat-stroked-button class="currentBtnColor" matTooltip="Enregistrer" (click)="onSave()">
          <mat-icon>save</mat-icon>
          <span class="long-btn-span" fxHide fxShow.gt-md>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>
</div>